import useMe from 'contexts/authentication/useMe';
import { useMemo } from 'react';

const useIsExcludedFromFullöDayPlanning = () => {
  const me = useMe();

  const isExcludedFromFullDayPlanning = useMemo(() => {
    if (!me) {
      return false;
    }

    return !!me.tempTestPlaceholderAssignments;
  }, [me]);

  return isExcludedFromFullDayPlanning;
};

export default useIsExcludedFromFullöDayPlanning;
